export const kAppConstants = {
	appStage: process.env.REACT_APP_STAGE,
	mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN,
	vapidPublicKey: process.env.REACT_APP_VAPID_PUBLIC_KEY,
	hotjarSiteId: process.env.REACT_APP_HOTJAR_SITE_ID,
};
